import React from 'react';
import {Redirect, Route, Switch} from "react-router-dom";
import OrgHistory from "./CounterAgents/OrgHistory";
import OrgHistoryPatients from "./CounterAgents/OrgHistoryPatients";
import AllPatients from "./Patients/AllPatients";
import {PatientQrResultSwitcher} from "../General/QrResult/QrResult";
import OrgSearch from "../General/OrgSearch";
import {PatientQrResultSwitcher2} from "../General/QrResult2/QrResult2";
import BookingOrganization from "./Booking/Booking.organization";
import NotificationsOrganization from "./Notifications/Notifications.organization";

function OrganizationRoutes() {
    const {REACT_APP_URL_PREFIX} = process.env
    return (
        <Switch>

            <Route path={REACT_APP_URL_PREFIX + '/orgSearch' } exact> <OrgSearch /></Route>

            <Route path={REACT_APP_URL_PREFIX + '/counterAgents/OrgHistory'} exact>
                <OrgHistory/>
            </Route>

            <Route path={REACT_APP_URL_PREFIX + "/booking"} exact>
                <BookingOrganization/>
            </Route>
            <Route path={REACT_APP_URL_PREFIX + "/notifications"} exact>
                <NotificationsOrganization/>
            </Route>

            <Route
                path={REACT_APP_URL_PREFIX + '/counterAgents/:verificationId/OrgHistory/:historyId/:historyName/patient'}
                exact>
                <OrgHistoryPatients/>
            </Route>

            <Route path={REACT_APP_URL_PREFIX + '/patients/allPatientList'} exact>
                <AllPatients/>
            </Route>
            <Route path={REACT_APP_URL_PREFIX + "/checkIn"} exact>
                <PatientQrResultSwitcher/>
            </Route>
            <Route path={REACT_APP_URL_PREFIX + '/checkBlank/:data'} exact> <PatientQrResultSwitcher2 /> </Route>

            <Redirect to={REACT_APP_URL_PREFIX + "/patients/allPatientList"}/>

        </Switch>
    )
}

export default OrganizationRoutes;